import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["isDisabled", "isLoading", "isActive", "children", "leftIcon", "rightIcon", "loadingText", "iconSpacing", "type", "spinner", "spinnerPlacement", "className", "as"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useButtonType } from "./chunk-FRFD4OXU.mjs";
import { useButtonGroup } from "./chunk-DGWZA2DU.mjs";
import { ButtonIcon } from "./chunk-HCASMTTF.mjs";
import { ButtonSpinner } from "./chunk-HNNHG6RU.mjs";

// src/button.tsx
import { useMergeRefs } from "@chakra-ui/react-use-merge-refs";
import { chakra, forwardRef, omitThemingProps, useStyleConfig } from "@chakra-ui/system";
import { cx, dataAttr } from "@chakra-ui/shared-utils";
import { useMemo } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Button = forwardRef(function (props, ref) {
  var group = useButtonGroup();
  var styles = useStyleConfig("Button", _objectSpread(_objectSpread({}, group), props));
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$isD = _omitThemingProps.isDisabled,
    isDisabled = _omitThemingProps$isD === void 0 ? group == null ? void 0 : group.isDisabled : _omitThemingProps$isD,
    isLoading = _omitThemingProps.isLoading,
    isActive = _omitThemingProps.isActive,
    children = _omitThemingProps.children,
    leftIcon = _omitThemingProps.leftIcon,
    rightIcon = _omitThemingProps.rightIcon,
    loadingText = _omitThemingProps.loadingText,
    _omitThemingProps$ico = _omitThemingProps.iconSpacing,
    iconSpacing = _omitThemingProps$ico === void 0 ? "0.5rem" : _omitThemingProps$ico,
    type = _omitThemingProps.type,
    spinner = _omitThemingProps.spinner,
    _omitThemingProps$spi = _omitThemingProps.spinnerPlacement,
    spinnerPlacement = _omitThemingProps$spi === void 0 ? "start" : _omitThemingProps$spi,
    className = _omitThemingProps.className,
    as = _omitThemingProps.as,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var buttonStyles = useMemo(function () {
    var _focus = _objectSpread(_objectSpread({}, styles == null ? void 0 : styles["_focus"]), {}, {
      zIndex: 1
    });
    return _objectSpread(_objectSpread({
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none"
    }, styles), !!group && {
      _focus: _focus
    });
  }, [styles, group]);
  var _useButtonType = useButtonType(as),
    _ref = _useButtonType.ref,
    defaultType = _useButtonType.type;
  var contentProps = {
    rightIcon: rightIcon,
    leftIcon: leftIcon,
    iconSpacing: iconSpacing,
    children: children
  };
  return /* @__PURE__ */jsxs(chakra.button, _objectSpread(_objectSpread({
    ref: useMergeRefs(ref, _ref),
    as: as,
    type: type != null ? type : defaultType,
    "data-active": dataAttr(isActive),
    "data-loading": dataAttr(isLoading),
    __css: buttonStyles,
    className: cx("chakra-button", className)
  }, rest), {}, {
    disabled: isDisabled || isLoading,
    children: [isLoading && spinnerPlacement === "start" && /* @__PURE__ */jsx(ButtonSpinner, {
      className: "chakra-button__spinner--start",
      label: loadingText,
      placement: "start",
      spacing: iconSpacing,
      children: spinner
    }), isLoading ? loadingText || /* @__PURE__ */jsx(chakra.span, {
      opacity: 0,
      children: /* @__PURE__ */jsx(ButtonContent, _objectSpread({}, contentProps))
    }) : /* @__PURE__ */jsx(ButtonContent, _objectSpread({}, contentProps)), isLoading && spinnerPlacement === "end" && /* @__PURE__ */jsx(ButtonSpinner, {
      className: "chakra-button__spinner--end",
      label: loadingText,
      placement: "end",
      spacing: iconSpacing,
      children: spinner
    })]
  }));
});
Button.displayName = "Button";
function ButtonContent(props) {
  var leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    children = props.children,
    iconSpacing = props.iconSpacing;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [leftIcon && /* @__PURE__ */jsx(ButtonIcon, {
      marginEnd: iconSpacing,
      children: leftIcon
    }), children, rightIcon && /* @__PURE__ */jsx(ButtonIcon, {
      marginStart: iconSpacing,
      children: rightIcon
    })]
  });
}
export { Button };